"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What types of residential projects do you handle?",
  answer: "Glencross Construction Ltd specialises in high-quality domestic buildings, including bespoke new-build homes, large-scale extensions, complete property renovations, and luxury residential developments tailored to your specific vision."
}, {
  question: "How do you ensure the quality of craftsmanship?",
  answer: "Our reputation is built on precision and structural integrity. We employ highly skilled tradespeople and maintain rigorous attention to detail at every stage, from the initial foundation work to the final architectural finishes."
}, {
  question: "Do you manage the entire construction process?",
  answer: "Yes, we provide a comprehensive end-to-end service. This includes project management, coordinating with architects and structural engineers, and ensuring all building regulations and safety standards are strictly met throughout the build."
}, {
  question: "Can you work with my existing architectural plans?",
  answer: "Absolutely. We frequently collaborate with clients' chosen architects to bring technical drawings to life. Our team excels at interpreting complex designs while offering practical construction expertise to ensure a seamless delivery."
}, {
  question: "What is the typical timeline for a new-build home?",
  answer: "Timelines vary based on the scale and complexity of the design. During our initial consultation, we provide a detailed project schedule that outlines key milestones, ensuring transparency and reliability from start to finish."
}];
export default function CommonQuestions() {
  return <section data-section-id="224876" id="common-questions" className="relative w-full bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" aria-hidden="true" />

      <div className="relative z-10 max-w-3xl mx-auto flex flex-col items-center">
        <div className="text-center mb-16 space-y-4">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter uppercase">
            Project <span className="text-primary">Insights</span>
          </h2>
          <p className="font-default text-muted-foreground text-lg md:text-xl max-w-xl mx-auto">
            Essential information regarding our construction standards, processes, and bespoke residential services.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full flex flex-col gap-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`faq-${i}`} data-index={i} className="group border border-border/60 rounded-sm px-6 py-2 bg-card/30 backdrop-blur-sm transition-all duration-300 ease-out data-[state=open]:bg-card data-[state=open]:border-primary/40 data-[state=open]:shadow-md">
              <AccordionTrigger className="font-default text-lg md:text-xl font-bold text-left hover:no-underline hover:text-primary transition-colors py-4 uppercase tracking-tight">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-default text-muted-foreground text-base leading-relaxed pb-6 pt-2">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}